<template>
    <v-container class="w-container-dati-coll v-overflow editDatiColl"
        style="padding-top: 59px;background-color: rgb(255 255 255 / 50%);">

        <v-row>


            <v-col class='mainCont' style="min-width:100vw;position:fixed;left:0;padding-left:0px;z-index:3">

                <div class="mainTitle" style="
                background-color: white;
                color: black;
                font-weight: bold;
                padding: 4px;
                font-size: 10px;
                min-width:100vw;
                border-color:#f5cf2e">{{ titolo }}</div>

            </v-col>

        </v-row>


        <v-form style="max-width:500px;" v-model="valid" ref="form" lazy-validation>



            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.name" label="Nome" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.surname" label="Cognome" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.mail" label="E-Mail" readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.tipo_contratto_descrizione" label="Tipo Contratto"
                        readonly></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.tel_cell" id="cellulare" label="Cellulare"
                        maxlength="13"></v-text-field>

                </v-col>

            </v-row>


            <v-row>

                <v-col cols="12" md="12">

                    <div style="margin-left:11px">
                        <label style="font-size:9px">Data Nascita</label>
                    </div>

                    <div style="margin-left:6px">
                        <date-picker v-model="collaboratore.data_nascita" type="date" valueType="format"
                            format="YYYY-MM-DD" class="cl-input-data"></date-picker>
                    </div>

                </v-col>

            </v-row>


            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.codice_fiscale" label="Codice Fiscale"
                        maxlength="16"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewPartitaIva">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.partita_iva" label="Partita IVA" maxlength="16"></v-text-field>

                </v-col>

            </v-row>



            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_titolostudio" style="cursor:pointer">
                        <ion-item id="itemIdRegioneRes"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Titolo Studio </ion-label>

                            <ion-select id="titolo_studio" name="titolo_studio" class='titolo_studio'
                                cancel-Text="Chiudi" done-Text="" :value="collaboratore.titolo_studio"
                                interface="action-sheet">

                                <ion-select-option v-for="item in titoli_studi" :key="item.id" :value='item.id'> {{
                                    item.nome }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <div
                        style="background:#8080808c;height:20px;padding:0;margin-left:-16px;min-width:382px;padding-left:5px;margin-bottom:10px">
                        <div style="font-size:12px;padding-left:3px;padding-top:3px;font-weight:bold">
                            Diploma
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.diploma_in" label="In" maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <div id="d_year"
                        class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <div class="v-text-field__slot"><label for="input-29"
                                        class="v-label v-label--active theme--light"
                                        style="left: 0px; right: auto; position: absolute">Anno</label>


                                    <vue-autonumeric id="valYear" v-model="collaboratore.diploma_anno" :options="{
                                        digitGroupSeparator: '',
                                        decimalCharacter: ',',
                                        decimalCharacterAlternative: '',
                                        currencySymbol: '',
                                        currencySymbolPlacement: 's',
                                        roundingMethod: 'U',
                                        minimumValue: '0',
                                        decimalPlaces: '0'
                                    }"></vue-autonumeric>

                                </div>
                            </div>

                            <div class="v-text-field__details">
                                <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper"></div>
                                </div>
                            </div>

                        </div>
                    </div>


                </v-col>

            </v-row>


            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.diploma_istituto" label="Istituto"
                        maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.diploma_voto" label="Voto" maxlength="20"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.diploma_citta" label="Città" maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewDiploma">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.diploma_provincia" label="Provincia"
                        maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <div
                        style="background:#8080808c;height:20px;padding:0;margin-left:-16px;min-width:382px;padding-left:5px;margin-bottom:10px">
                        <div style="font-size:12px;padding-left:3px;padding-top:3px;font-weight:bold">
                            Laurea
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.laurea_in" label="In" maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <ion-item id="itemAutoMunito"
                        style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                        <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                            position="floating">Tipo Laurea </ion-label>

                        <ion-select id="idtipolaurea" name="idtipolaurea" class='idtipolaurea' cancel-Text="Chiudi"
                            done-Text="" :value="collaboratore.idtipolaurea" interface="action-sheet">

                            <ion-select-option v-for="item in tipolaurea" :key="item.idtipolaurea"
                                :value='item.idtipolaurea'> {{ item.descrizione }}</ion-select-option>

                        </ion-select>
                    </ion-item>

                </v-col>

            </v-row>


            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.laurea_istituto" label="Istituto"
                        maxlength="50"></v-text-field>

                </v-col>

            </v-row>


            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <div id="d_year"
                        class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <div class="v-text-field__slot"><label for="input-29"
                                        class="v-label v-label--active theme--light"
                                        style="left: 0px; right: auto; position: absolute">Anno</label>


                                    <vue-autonumeric id="valYear" v-model="collaboratore.laurea_data_iscrizione"
                                        :options="{
                                            digitGroupSeparator: '',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '',
                                            currencySymbol: '',
                                            currencySymbolPlacement: 's',
                                            roundingMethod: 'U',
                                            minimumValue: '0',
                                            decimalPlaces: '0'
                                        }"></vue-autonumeric>

                                </div>
                            </div>

                            <div class="v-text-field__details">
                                <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper"></div>
                                </div>
                            </div>

                        </div>
                    </div>



                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.laurea_voto" label="Voto" maxlength="20"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.laurea_citta" label="Città" maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row v-if="viewLaurea">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.laurea_provincia" label="Provincia"
                        maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div class="subTitle">
                        <div>
                            Residenza
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.indirizzo" label="Indirizzo" maxlength="50"></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_idregione_res" style="cursor:pointer">
                        <ion-item id="itemIdRegioneRes"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Regione </ion-label>

                            <ion-select id="regione_res" name="regione_res" class='regione_res' cancel-Text="Chiudi"
                                done-Text="" :value="collaboratore.regione_res" interface="action-sheet" disabled
                                readonly>

                                <ion-select-option v-for="item in regioniRes" :key="item.nome_regione"
                                    :value='item.nome_regione'> {{
                                        item.nome_regione }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewProvRes">

                <v-col cols="12" md="12">

                    <div id="cont_idprovincia_res" style="cursor:pointer">
                        <ion-item id="itemProvinciaRes"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Provincia</ion-label>

                            <ion-select id="provincia_res" name="provincia_res" class='provincia_res'
                                cancel-Text="Chiudi" done-Text="" :value="collaboratore.provincia_res"
                                interface="action-sheet" disabled readonly>

                                <ion-select-option v-for="item in provinceRes" :key="item.nome_provincia"
                                    :value='item.nome_provincia'> {{
                                        item.nome_provincia
                                    }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewComRes">

                <v-col cols="12" md="12">

                    <div id="cont_idcomune_res" style="cursor:pointer">
                        <ion-item id="itemComuneRes"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Comune</ion-label>

                            <ion-select id="citta_res" name="citta_res" class='citta_res' cancel-Text="Chiudi"
                                done-Text="" :value="collaboratore.citta_res" interface="action-sheet" disabled
                                readonly>

                                <ion-select-option v-for="item in comuniRes" :key="item.nome_comune"
                                    :value='item.nome_comune'> {{ item.nome_comune
                                    }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewCapRes">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.cap_res" label="CAP" maxlength="10"></v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div class="subTitle">
                        <div>
                            Domicilio
                        </div>
                    </div>

                </v-col>

            </v-row>


            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.indirizzo_dom" label="Indirizzo" maxlength="50"></v-text-field>

                </v-col>

            </v-row>



            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_idregione_dom" style="cursor:pointer">
                        <ion-item id="itemIdRegioneDom"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Regione </ion-label>

                            <ion-select id="regione_dom" name="regione_dom" class='regione_dom' cancel-Text="Chiudi"
                                done-Text="" :value="collaboratore.regione_dom" interface="action-sheet" disabled
                                readonly>

                                <ion-select-option v-for="item in regioniDom" :key="item.nome_regione"
                                    :value='item.nome_regione'> {{
                                        item.nome_regione }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewProvDom">

                <v-col cols="12" md="12">

                    <div id="cont_idprovincia_dom" style="cursor:pointer">
                        <ion-item id="itemProvinciaDom"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Provincia</ion-label>

                            <ion-select id="provincia_dom" name="provincia_dom" class='provincia_dom'
                                cancel-Text="Chiudi" done-Text="" :value="collaboratore.provincia_dom"
                                interface="action-sheet" disabled readonly>

                                <ion-select-option v-for="item in provinceDom" :key="item.nome_provincia"
                                    :value='item.nome_provincia'> {{
                                        item.nome_provincia
                                    }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewComDom">

                <v-col cols="12" md="12">

                    <div id="cont_idcomune_dom" style="cursor:pointer">
                        <ion-item id="itemComuneDom"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:#9a9a9a!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Comune</ion-label>

                            <ion-select id="citta_dom" name="citta_dom" class='citta_dom' cancel-Text="Chiudi"
                                done-Text="" :value="collaboratore.citta_dom" interface="action-sheet" disabled
                                readonly>

                                <ion-select-option v-for="item in comuniDom" :key="item.nome_comune"
                                    :value='item.nome_comune'> {{ item.nome_comune
                                    }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>


            <v-row v-if="viewCapDom">

                <v-col cols="12" md="12">

                    <v-text-field v-model="collaboratore.cap_dom" label="CAP" maxlength="10"></v-text-field>

                </v-col>

            </v-row>


            <v-row>

                <v-col cols="12" md="12" style="display:flex;align-items:center">

                    <div class="copyAddress">
                        <v-img alt="Vuetify Logo" class="  " contain src="@/assets/copy_element.png" max-width="20"
                            max-height="20" transition="scale-transition" style="margin-top:4px!important" />
                    </div>

                    <div style="margin-left:10px;font-weight:bold">
                        Copia dalla residenza
                    </div>

                </v-col>

            </v-row>


            <v-row>

                <v-col cols="12" md="12">


                    <div class="subTitle">
                        <div>
                            Copia Carta Identità
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row id="rowCIFronte">

                <v-col cols="12" md="12">

                    <span class="files">
                        <label>Fronte</label>
                        <input type="file" id="input-file-ci-fronte" name="logo" accept=".png,.jpg,.jpeg"
                            class="dropify" data-max-width="6610" data-max-height="6200" />
                    </span>

                </v-col>

            </v-row>

            <v-row id="rowCIRetro">

                <v-col cols="12" md="12">

                    <span class="files">
                        <label>Retro</label>
                        <input type="file" id="input-file-ci-retro" name="logo" accept=".png,.jpg,.jpeg" class="dropify"
                            data-max-width="6610" data-max-height="6200" />
                    </span>

                </v-col>

            </v-row>



            <v-row>

                <v-col cols="12" md="12">


                    <div class="subTitle">
                        <div>
                            Copia Codice Fiscale
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row id="rowCFFronte">

                <v-col cols="12" md="12">

                    <span class="files">
                        <label>Fronte</label>
                        <input type="file" id="input-file-cf-fronte" name="logo" accept=".png,.jpg,.jpeg"
                            class="dropify" data-max-width="6610" data-max-height="6200" />
                    </span>

                </v-col>

            </v-row>

            <v-row id="rowCFRetro">

                <v-col cols="12" md="12">

                    <span class="files">
                        <label>Retro</label>
                        <input type="file" id="input-file-cf-retro" name="logo" accept=".png,.jpg,.jpeg" class="dropify"
                            data-max-width="6610" data-max-height="6200" />
                    </span>

                </v-col>

            </v-row>



        </v-form>

        <div class="contregionires">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetRegioniRes" class="vregionisheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetRegioni" fixed style="position:fixed;">
                                Regioni
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetRegioniRes = !sheetRegioniRes">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchRegioniRes">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:79px"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredRegioniRes"
                                        :key="item.nome_regione" @click="manageClickRegioneRes(item)">

                                        <v-img alt="Regioni Logo" class="  " contain src="@/assets/2recr_regioni.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemRegione'>{{ item.nome_regione
                                            }}</v-list-item-title>
                                    </v-list-item>

                                </v-card>
                            </v-flex>

                            <div style="min-height:170px;height:170px">&nbsp;</div>

                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contprovinceres">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetProvinceRes" class="vprovincesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetProvince" fixed style="position:fixed;">
                                Province
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetProvinceRes = !sheetProvinceRes">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchProvinceRes">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredProvinceRes"
                                        :key="item.nome_provincia" @click="manageClickProvinciaRes(item)">

                                        <v-img alt="Province Logo" class="  " contain src="@/assets/2recr_province.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemProvincia'>{{ item.nome_provincia
                                        }}</v-list-item-title>
                                    </v-list-item>
                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contcomunires">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetComuniRes" class="vcomunisheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetComuni" fixed style="position:fixed;">
                                Comuni
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetComuniRes = !sheetComuniRes">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchComuniRes">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class=" spacer" style="min-height:72px;">
                            </div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredComuniRes"
                                        :key="item.nome_comune" @click="manageClickComuneRes(item)">

                                        <v-img alt="Comuni Logo" class="  " contain src="@/assets/2recr_comuni.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemComune'>{{ item.nome_comune }}</v-list-item-title>
                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contregionidom">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetRegioniDom" class="vregionisheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetRegioni" fixed style="position:fixed;">
                                Regioni
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetRegioniDom = !sheetRegioniDom">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchRegioniDom">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:79px"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredRegioniDom"
                                        :key="item.nome_regione" @click="manageClickRegioneDom(item)">

                                        <v-img alt="Regioni Logo" class="  " contain src="@/assets/2recr_regioni.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemRegione'>{{ item.nome_regione
                                        }}</v-list-item-title>
                                    </v-list-item>

                                </v-card>
                            </v-flex>

                            <div style="min-height:170px;height:170px">&nbsp;</div>

                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contprovincedom">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetProvinceDom" class="vprovincesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetProvince" fixed style="position:fixed;">
                                Province
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetProvinceDom = !sheetProvinceDom">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchProvinceDom">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredProvinceDom"
                                        :key="item.nome_provincia" @click="manageClickProvinciaDom(item)">

                                        <v-img alt="Province Logo" class="  " contain src="@/assets/2recr_province.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemProvincia'>{{ item.nome_provincia
                                        }}</v-list-item-title>
                                    </v-list-item>
                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

        <div class="contcomunidom">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetComuniDom" class="vcomunisheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetComuni" fixed style="position:fixed;">
                                Comuni
                                <v-btn class='closeSheet align_close_sheet' icon
                                    @click="sheetComuniDom = !sheetComuniDom">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_emt.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchComuniDom">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class=" spacer" style="min-height:72px;">
                            </div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredComuniDom"
                                        :key="item.nome_comune" @click="manageClickComuneDom(item)">

                                        <v-img alt="Comuni Logo" class="  " contain src="@/assets/2recr_comuni.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemComune'>{{ item.nome_comune }}</v-list-item-title>
                                    </v-list-item>

                                    <div style="min-height:150px;height:150px">&nbsp;</div>

                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>

    </v-container>
</template>

<script>
import apitimesheet from "../utils/timesheet/apitimesheet";

import {
    bus
} from "../main";


import Vue from "vue";
import VModal from 'vue-js-modal';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/it';

import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';

//import CodiceFiscale from 'codice-fiscale-js';

export default ({
    mounted() {



        if (window.idAziendaCandidato == undefined) {

            this.$router.push('/')

        }



        Vue.use(VModal, {
            dialog: true
        });

        /*eslint-disable no-undef*/

        var pointerVue = this;

        //window.$cookies.get("aziende_user")

        this.setupButtons();

        setTimeout(() => {

            pointerVue.initDatiCollaboratore();

        }, 200);


        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {

                case "btn_save":

                    this.validate();

                    break;

                default:
                    break;
            }
        });

        $(document).ready(function () {

            $('body').on('input', '#cellulare', function () {

                let value = $("#cellulare").val().replace(/\D/g, "");

                value = value.replace(/\D/g, "");

                // Applica la formattazione: 3-3-2-2
                let formatted = "";
                if (value.length > 0) {
                    formatted += value.substring(0, 3);
                }
                if (value.length > 3) {
                    formatted += " " + value.substring(3, 6);
                }
                if (value.length > 6) {
                    formatted += " " + value.substring(6, 8);
                }
                if (value.length > 8) {
                    formatted += " " + value.substring(8, 10);
                }

                $("#cellulare").val(formatted)

            });

            $('body').on('ionChange', '.genere', function (event) {
                console.log(event);

                pointerVue.collaboratore.genere = this.value;

            });


            $('body').on('click', '#cont_idregione_res', function (event) {
                console.log(event);

                pointerVue.sheetRegioniRes = true;

            });

            $('body').on('click', '#cont_idprovincia_res', function (event) {
                console.log(event);

                pointerVue.sheetProvinceRes = true;

            });

            $('body').on('click', '#cont_idcomune_res', function (event) {
                console.log(event);

                pointerVue.sheetComuniRes = true;

            });

            $('body').on('click', '#cont_idregione_dom', function (event) {
                console.log(event);

                pointerVue.sheetRegioniDom = true;

            });

            $('body').on('click', '#cont_idprovincia_dom', function (event) {
                console.log(event);

                pointerVue.sheetProvinceDom = true;

            });

            $('body').on('click', '#cont_idcomune_dom', function (event) {
                console.log(event);

                pointerVue.sheetComuniDom = true;

            });

            $('body').on('click', '.copyAddress', function (event) {
                console.log(event);

                pointerVue.collaboratore.indirizzo_dom = pointerVue.collaboratore.indirizzo;


                if (pointerVue.collaboratore.regione_res != null) {

                    pointerVue.collaboratore.regione_dom = pointerVue.collaboratore.regione_res;

                    pointerVue.viewProvDom = true;

                    pointerVue.setProvinceDom(pointerVue.collaboratore.regione_dom);

                }

                if (pointerVue.collaboratore.provincia_res != null) {

                    pointerVue.collaboratore.provincia_dom = pointerVue.collaboratore.provincia_res;

                    pointerVue.viewComDom = true;


                    pointerVue.setComuniDom(pointerVue.collaboratore.provincia_res);

                    $("#itemProvinciaDom").addClass("item-has-value");

                }

                if (pointerVue.collaboratore.citta_res != null) {

                    pointerVue.collaboratore.citta_dom = pointerVue.collaboratore.citta_res;

                    $("#itemComuneDom").addClass("item-has-value");

                }

                pointerVue.viewCapDom = true;

                pointerVue.collaboratore.cap_dom = pointerVue.collaboratore.cap_res;

            });


            $('body').on('ionChange', '.titolo_studio', function (event) {
                console.log(event);

                pointerVue.collaboratore.titolo_studio = this.value;

                pointerVue.viewDiploma = false;
                pointerVue.viewLaurea = false;

                if (this.value == "Diploma") {
                    pointerVue.viewDiploma = true;
                }

                if (this.value == "Laurea") {
                    pointerVue.viewDiploma = true;
                    pointerVue.viewLaurea = true;
                }

            });

            $('body').on('ionChange', '.idtipolaurea', function (event) {
                console.log(event);

                pointerVue.collaboratore.idtipolaurea = this.value;


            });



        });


        $(".bottomBtnMenu").hide();


        this.loadLogo();

        this.$root.$children[0].viewLinkLogo = false;


    },



    data: () => ({

        viewPartitaIva: false,

        tipi_contratto: [
            {
                contratto: "APS",
                descrizione: "Apprendistato"
            },
            {
                contratto: "CINT",
                descrizione: "Cassa Integrazione"
            },
            {
                contratto: "DET",
                descrizione: "Determinato (IT)"
            },
            {
                contratto: "DIS",
                descrizione: "Disoccupato"
            },
            {
                contratto: "FOR",
                descrizione: "Fornitore"
            },
            {
                contratto: "IND",
                descrizione: "Indeterminato (IT)"
            },
            {
                contratto: "MOB",
                descrizione: "Mobilità"
            },
            {
                contratto: "PIVA",
                descrizione: "Partita IVA"
            },
            {
                contratto: "RIT",
                descrizione: "Ritenuta"
            },
            {
                contratto: "STG",
                descrizione: "Stage"
            },
            {
                contratto: "TCN",
                descrizione: "Tirocinio"
            }

        ],


        lista_genere: [
            {
                id: "M",
                description: "Maschio"
            },
            {
                id: "F",
                description: "Femmina"
            }
        ],

        tipolaurea: [],

        viewLaurea: false,

        viewDiploma: false,

        titoli_studi: [
            {
                id: "Diploma",
                nome: "Diploma"
            },
            {
                id: "Laurea",
                nome: "Laurea"
            }
        ],

        sheetComuniDom: false,
        searchComuniDom: "",

        sheetProvinceDom: false,
        searchProvinceDom: "",

        sheetRegioniDom: false,
        searchRegioniDom: "",

        viewProvDom: false,
        viewComDom: false,
        viewCapDom: false,



        sheetComuniRes: false,
        searchComuniRes: "",


        sheetProvinceRes: false,
        searchProvinceRes: "",


        sheetRegioniRes: false,
        searchRegioniRes: "",

        viewProvRes: false,
        viewComRes: false,
        viewCapRes: false,

        regioniRes: [],
        provinceRes: [],
        comuniRes: [],
        provinceResTemp: [],
        comuniResTemp: [],

        regioniDom: [],
        provinceDom: [],
        provinceDomTemp: [],
        comuniDom: [],
        comuniDomTemp: [],

        collaboratore: {
            name: "",
            surname: "",
            mail: "",
            tel_cell: "",
            codice_fiscale: "",
            data_nascita: "",
            indirizzo: "",
            regione_res: "",
            provincia_res: "",
            citta_res: "",
            cap_res: "",
            indirizzo_dom: "",
            regione_dom: "",
            provincia_dom: "",
            citta_dom: "",
            cap_dom: "",
            diploma_in: "",
            diploma_anno: "",
            diploma_istituto: "",
            diploma_voto: "",
            diploma_citta: "",
            diploma_provincia: "",
            laurea_in: "",
            idtipolaurea: "",
            laurea_istituto: "",
            laurea_data_iscrizione: "",
            laurea_data_termine: "",
            laurea_voto: "",
            laurea_citta: "",
            laurea_provincia: "",
            titolo_studio: "",
            companyid: "",
            genere: "",
            citta_nascita: "",
            tipo_contratto_impiegato: "",
            tipo_contratto_descrizione: "",
            partita_iva: ""
        },

        mailCandidato: "",

        nomeCandidato: "",

        cognomeCandidato: "",

        selAzienda: "",

        pdfUrl: "",

        visMemNB: false,
        visDiscoNB: false,

        risNomeSede: "",

        attachRemove: false,

        sheetRisorse: false,

        fidoAnt: null,
        fidoCassa: null,

        visDescrizione: false,
        visNMatricola: false,
        visOP: false,
        visSw: false,

        visNSim: false,
        visTelNum: false,

        visTarga: false,
        visVeicolo: false,

        visTipoDisco: false,

        visPollici: false,



        sheetGruppi: false,

        searchGruppi: "",

        tipo_cespiti: [],

        risorse: [],

        banca: {},

        cespiti: {
            hours: null
        },

        showPicker2: false,

        valoreMassimale: null,

        changePsw: false,

        titolo: "Informazioni e documenti",
        currDipendenteObj: {},

        gruppi_checked: [],

        isCurrentUserSU: "N",

        aziende: [],
        prefissi: [],

        dipendenti: [],
        currAzienda: "",

        gruppi: [],

        selNuclei: null,

        tab: null,

        cur_id: 0,

        sheetAziende: false,
        sheetDipendenti: false,
        searchDipendenti: "",
        search: "",

        showPicker: false,
        utente: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) => (v && v.length <= 16) || "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) => (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [
            (v) => !!v || "Field required",

        ],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail richiesta",
            (v) => /.+@.+\..+/.test(v) || "E-mail non valida",
        ],

        nameRules: [
            (v) => !!v || "Nome richiesto",
        ],

        phoneRules: [
            (v) => !!v || "Telefono richiesto",
        ],

        nucleoRules: [
            (v) => !!v || "Nucleo richiesto",
        ],

        fiscodeRules: [
            (v) => !!v || "Codice fiscale richiesto",
        ],

        surnameRules: [
            (v) => !!v || "Cognome richiesto",
        ],

        aziendaRules: [
            (v) => !!v || "Azienda richiesta",
        ],

        usernameRules: [
            (v) => !!v || "Username richiesto",
        ],

        select: null,

        // items: [
        //     'Informazioni Generali', 'Gruppo', 'Autenticazione', 'QR Code'
        // ],

        items: [
            'Informazioni', 'Gruppo', 'Nota Spese'
        ],

        checkbox: false,

        tipo_qrcode: [{
            "id": "USR_PWD",
            "value": "Utente E Password"
        },
        {
            "id": "FCODE_PWD",
            "value": "Utente E Codice Fiscale"
        }
        ],

        tipi_dischi: [{
            "id": "RPM",
            "value": "RPM"
        },
        {
            "id": "SSD",
            "value": "SSD"
        }
        ]

    }),


    computed: {

        filteredRegioniRes() {

            return _.orderBy(this.regioniRes.filter(item => {
                if (!this.searchRegioniRes) return this.regioniRes;
                return (item.nome_regione.toLowerCase().includes(this.searchRegioniRes.toLowerCase()));
            }), 'headline')
        },

        filteredProvinceRes() {

            return _.orderBy(this.provinceRes.filter(item => {
                if (!this.searchProvinceRes) return this.provinceRes;
                return (item.nome_provincia.toLowerCase().includes(this.searchProvinceRes.toLowerCase()));
            }), 'headline')
        },

        filteredComuniRes() {

            return _.orderBy(this.comuniRes.filter(item => {
                if (!this.searchComuniRes) return this.comuniRes;
                return (item.nome_comune.toLowerCase().includes(this.searchComuniRes.toLowerCase()));
            }), 'headline')
        },

        filteredRegioniDom() {

            return _.orderBy(this.regioniDom.filter(item => {
                if (!this.searchRegioniDom) return this.regioniDom;
                return (item.nome_regione.toLowerCase().includes(this.searchRegioniDom.toLowerCase()));
            }), 'headline')
        },

        filteredProvinceDom() {

            return _.orderBy(this.provinceDom.filter(item => {
                if (!this.searchProvinceDom) return this.provinceDom;
                return (item.nome_provincia.toLowerCase().includes(this.searchProvinceDom.toLowerCase()));
            }), 'headline')
        },

        filteredComuniDom() {

            return _.orderBy(this.comuniDom.filter(item => {
                if (!this.searchComuniDom) return this.comuniDom;
                return (item.nome_comune.toLowerCase().includes(this.searchComuniDom.toLowerCase()));
            }), 'headline')
        },

    },


    methods: {


        validaPartitaIVA: function (piva) {

            if (typeof piva !== 'string') return false;

            // Rimuove "IT", spazi, trattini, ecc.
            piva = piva.toUpperCase().replace(/^IT/, '').replace(/\s|-/g, '');

            if (!/^\d{11}$/.test(piva)) return false;

            let s = 0;
            for (let i = 0; i < 10; i++) {
                let n = parseInt(piva.charAt(i), 10);
                if ((i % 2) === 0) {
                    s += n;
                } else {
                    n *= 2;
                    if (n > 9) n -= 9;
                    s += n;
                }
            }
            let checkDigit = (10 - (s % 10)) % 10;
            return checkDigit === parseInt(piva.charAt(10), 10);


        },

        validaCodiceFiscale: function (cf) {

            if (typeof cf !== 'string') return false;

            cf = cf.toUpperCase().trim();

            if (!/^[A-Z0-9]{16}$/.test(cf)) return false;

            const evenMap = {
                '0': 0, '1': 1, '2': 2, '3': 3, '4': 4,
                '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
                'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4,
                'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
                'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14,
                'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
                'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
            };

            const oddMap = {
                '0': 1, '1': 0, '2': 5, '3': 7, '4': 9,
                '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
                'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9,
                'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
                'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11,
                'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14,
                'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
            };

            let sum = 0;

            for (let i = 0; i < 15; i++) {
                const c = cf[i];
                sum += (i % 2 === 0) ? oddMap[c] : evenMap[c];
            }

            const expectedCheckChar = String.fromCharCode((sum % 26) + 'A'.charCodeAt(0));
            return cf[15] === expectedCheckChar;


        },



        loadLogo: async function () {

            console.log("LOAD LOGO API");


            try {
                var response = await this.$api
                    .LoadLogoCompanyNew2CreateColl(window.idAziendaCandidato, "emtool")
                    .then((res) => {

                        console.log("res LoadLogoCompanyNew2CreateColl: ", res);

                        this.$root.$children[0].pathLogoImage = res.data.UrlLogo;




                    });
            } catch (error) {
                console.log("err LoadLogoCompanyNew", error);
            }

            console.log(response);



        },

        manageClickComuneDom: async function (comune) {

            console.log("COM SEL: ", comune);

            this.sheetComuniDom = false;

            this.viewCapDom = true;

            this.collaboratore.citta_dom = comune.nome_comune;


        },

        manageClickProvinciaDom: async function (provincia) {

            console.log("PROV SEL: ", provincia);

            this.sheetProvinceDom = false;

            this.collaboratore.provincia_dom = provincia.nome_provincia;

            this.collaboratore.citta_dom = null;

            this.comuniDom = [];

            this.viewComDom = true;

            this.setComuniDom(provincia.nome_provincia);


        },


        setComuniDom: function (nome_provincia) {

            console.log("PROV SEL 2: ", nome_provincia);

            console.log("COM TMP: ", this.comuniDomTemp);

            var ComuniDom = [];

            for (var i = 0; i < this.comuniDomTemp.length; i++) {

                if (this.comuniDomTemp[i].nome_provincia == nome_provincia) {

                    ComuniDom.push({
                        nome_provincia: this.comuniDomTemp[i].nome_provincia,
                        nome_comune: this.comuniDomTemp[i].nome_comune
                    });

                }

            }

            console.log("COM. SEL: ", ComuniDom);

            this.comuniDom = ComuniDom;

        },

        manageClickRegioneDom: async function (regione) {

            console.log("REG SEL: ", regione);

            this.sheetRegioniDom = false;

            this.collaboratore.regione_dom = regione.nome_regione;

            this.collaboratore.provincia_dom = null;
            this.collaboratore.citta_dom = null;

            this.provinceDom = [];
            this.comuniDom = [];

            this.viewProvDom = true;

            this.setProvinceDom(regione.nome_regione);



        },

        setProvinceDom: function (nome_regione) {

            console.log("REG SEL 2: ", nome_regione);

            console.log("PROV TMP: ", this.provinceDomTemp);

            var ProvinceDom = [];

            for (var i = 0; i < this.provinceDomTemp.length; i++) {

                if (this.provinceDomTemp[i].nome_regione == nome_regione) {

                    ProvinceDom.push({
                        nome_regione: this.provinceDomTemp[i].nome_regione,
                        nome_provincia: this.provinceDomTemp[i].nome_provincia
                    });

                }

            }

            console.log("PROV SEL: ", ProvinceDom);

            this.provinceDom = ProvinceDom;

        },

        manageClickComuneRes: async function (comune) {

            console.log("COM SEL: ", comune);

            this.sheetComuniRes = false;

            this.viewCapRes = true;

            this.collaboratore.citta_res = comune.nome_comune;


        },

        setComuniRes: function (nome_provincia) {

            console.log("PROV SEL 2: ", nome_provincia);

            console.log("COM TMP: ", this.comuniResTemp);

            var ComuniRes = [];

            for (var i = 0; i < this.comuniResTemp.length; i++) {

                if (this.comuniResTemp[i].nome_provincia == nome_provincia) {

                    ComuniRes.push({
                        nome_provincia: this.comuniResTemp[i].nome_provincia,
                        nome_comune: this.comuniResTemp[i].nome_comune
                    });

                }

            }

            console.log("COM. SEL: ", ComuniRes);

            this.comuniRes = ComuniRes;

        },

        manageClickProvinciaRes: async function (provincia) {

            console.log("PROV SEL: ", provincia);

            this.sheetProvinceRes = false;

            this.collaboratore.provincia_res = provincia.nome_provincia;

            this.collaboratore.citta_res = null;

            this.comuniRes = [];

            this.viewComRes = true;

            this.setComuniRes(provincia.nome_provincia);


        },

        manageClickRegioneRes: async function (regione) {

            console.log("REG SEL: ", regione);

            this.sheetRegioniRes = false;

            this.collaboratore.regione_res = regione.nome_regione;

            this.collaboratore.provincia_res = null;
            this.collaboratore.citta_res = null;

            this.provinceRes = [];
            this.comuniRes = [];

            this.viewProvRes = true;

            this.setProvinceRes(regione.nome_regione);



        },

        setProvinceRes: function (nome_regione) {

            console.log("REG SEL 2: ", nome_regione);

            console.log("PROV TMP: ", this.provinceResTemp);

            var ProvinceRes = [];

            for (var i = 0; i < this.provinceResTemp.length; i++) {

                if (this.provinceResTemp[i].nome_regione == nome_regione) {

                    ProvinceRes.push({
                        nome_regione: this.provinceResTemp[i].nome_regione,
                        nome_provincia: this.provinceResTemp[i].nome_provincia
                    });

                }

            }

            console.log("PROV SEL: ", ProvinceRes);

            this.provinceRes = ProvinceRes;

        },


        initDatiCollaboratore: async function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apitimesheet.initDatiCollaboratore(
                0
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initDatiCollaboratore", res);

                this.regioniRes = res.data.regioni;
                this.provinceResTemp = res.data.province;
                this.comuniResTemp = res.data.comuni;

                this.regioniDom = res.data.regioni;
                this.provinceDomTemp = res.data.province;
                this.comuniDomTemp = res.data.comuni;

                this.tipolaurea = res.data.tipolaurea;

                this.collaboratore.name = window.nomeCandidato;
                this.collaboratore.surname = window.cognomeCandidato;
                this.collaboratore.mail = window.emailCandidato;


                var v_contratto = "";
                var v_desc_contratto = "";
                for (var x_contr = 0; x_contr < this.tipi_contratto.length; x_contr++) {

                    if (window.tipoContrattoCandidato == this.tipi_contratto[x_contr].contratto) {
                        v_contratto = this.tipi_contratto[x_contr].contratto;
                        v_desc_contratto = this.tipi_contratto[x_contr].descrizione;
                    }

                }

                this.collaboratore.tipo_contratto_descrizione = v_desc_contratto;
                this.collaboratore.tipo_contratto_impiegato = v_contratto;

                if (window.tipoContrattoCandidato == "PIVA") {
                    this.viewPartitaIva = true;
                }


                setTimeout(() => {

                    var oggDrop = $('.dropify').dropify({
                        messages: {
                            default: 'Drag',
                            replace: /* s */ '',
                            remove: 'Rimuovi',
                            error: 'File troppo grande'
                        }
                    });

                    $(".dropify-clear").html("<img src='https://app.smart-book.it/_lib/img/icons8-cestino-64.png' />")
                    $(".dropify-render").append("<img>");

                    oggDrop.on('dropify.afterClear', function (event, element) {

                        console.log(event, element);


                    });

                }, 200);

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },


        setupButtons: async function () {

            setTimeout(() => {

                var pulsantis = [{
                    text: "Conferma",
                    icon: "mdi-content-save",
                    image: "https://app.emtool.eu/public/_lib/img/icon_save_emt.png",
                    link: "/timesheet",
                    id: "btn_save",
                    disabled: false,
                    title: "Salva",
                    width: 30
                },

                ];

                this.$root.$children[0].bnavbuttons = pulsantis;

                setTimeout(() => {
                }, 100);

            }, 100);

        },



        validate() {

            var that = this;

            var errore = "";

            if (that.collaboratore.name == "") {
                errore = "Specificare il nome";
            }

            if (errore == "") {
                if (that.collaboratore.surname == "") {
                    errore = "Specificare il cognome";
                }
            }

            if (errore == "") {
                if (that.collaboratore.mail == "") {
                    errore = "Specificare la mail";
                }
            }

            if (errore == "") {
                if (that.collaboratore.tel_cell == "") {
                    errore = "Specificare il cellulare";
                }
            }

            if (errore == "") {
                if (that.collaboratore.data_nascita == "") {
                    errore = "Specificare la data di nascita";
                }
            }

            if (errore == "") {
                if (that.collaboratore.codice_fiscale == "") {
                    errore = "Specificare il codice fiscale";
                }
            }

            if (errore == "") {
                if (!that.validaCodiceFiscale(that.collaboratore.codice_fiscale.toUpperCase())) {
                    errore = "Codice fiscale non valido";
                }
            }

            if (errore == "") {
                if (that.viewPartitaIva) {
                    if (that.collaboratore.partita_iva == "") {
                        errore = "Specificare la partita iva";
                    }
                }
            }

            if (errore == "") {
                if (that.viewPartitaIva) {
                    if (!that.validaPartitaIVA(that.collaboratore.partita_iva)) {
                        errore = "Partita iva non valida";
                    }
                }
            }




            if (errore == "") {
                if (that.collaboratore.indirizzo == "") {
                    errore = "Specificare il valore di indirizzo nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.regione_res == "") {
                    errore = "Specificare il valore di regione nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_res == "") {
                    errore = "Specificare il valore di provincia nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_res == null) {
                    errore = "Specificare il valore di provincia nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_res == "") {
                    errore = "Specificare il valore di comune nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_res == null) {
                    errore = "Specificare il valore di comune nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.cap_res == "") {
                    errore = "Specificare il valore di CAP nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.indirizzo_dom == "") {
                    errore = "Specificare il valore di indirizzo nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.regione_dom == "") {
                    errore = "Specificare il valore di regione nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_dom == "") {
                    errore = "Specificare il valore di provincia nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_dom == null) {
                    errore = "Specificare il valore di provincia nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_dom == "") {
                    errore = "Specificare il valore di comune nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_dom == null) {
                    errore = "Specificare il valore di comune nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.cap_dom == "") {
                    errore = "Specificare il valore di CAP nella sezione domicilio";
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-fronte")[0].files.length == 0) {
                    errore = "Specificare il file fronte della carta d'identità";
                }
            }


            if (errore == "") {
                if ($("#input-file-ci-fronte")[0].files.length > 0) {
                    var estensione = $("#input-file-ci-fronte")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione != "pdf") && (estensione != "jpeg") && (estensione != "jpg") && (estensione != "gif") && (estensione != "png")) {
                        errore = "Formati accettati nel file fronte della carta d'identità PDF, JPEG, JPG, GIF, PNG";

                    }
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-retro")[0].files.length == 0) {
                    errore = "Specificare il file retro della carta d'identità";
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-retro")[0].files.length > 0) {
                    var estensione2 = $("#input-file-ci-retro")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione2 != "pdf") && (estensione2 != "jpeg") && (estensione2 != "jpg") && (estensione2 != "gif") && (estensione2 != "png")) {
                        errore = "Formati accettati nel file retro della carta d'identità PDF, JPEG, JPG, GIF, PNG";

                    }
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-fronte")[0].files.length == 0) {
                    errore = "Specificare il file fronte del codice fiscale";
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-fronte")[0].files.length > 0) {
                    var estensione3 = $("#input-file-cf-fronte")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione3 != "pdf") && (estensione3 != "jpeg") && (estensione3 != "jpg") && (estensione3 != "gif") && (estensione3 != "png")) {
                        errore = "Formati accettati nel file fronte del codice fiscale PDF, JPEG, JPG, GIF, PNG";
                    }
                }
            }


            if (errore == "") {
                if ($("#input-file-cf-retro")[0].files.length == 0) {
                    errore = "Specificare il file retro del codice fiscale";
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-retro")[0].files.length > 0) {
                    var estensione4 = $("#input-file-cf-retro")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione4 != "pdf") && (estensione4 != "jpeg") && (estensione4 != "jpg") && (estensione4 != "gif") && (estensione4 != "png")) {
                        errore = "Formati accettati nel file retro del codice fiscale PDF, JPEG, JPG, GIF, PNG";
                    }
                }
            }


            if (errore == "") {



                console.log("ok");


                that.saveData();


            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },

        validateOld() {

            var that = this;



            // const cf = new CodiceFiscale({
            //     nome: 'Mauro',
            //     cognome: 'Cipolla',
            //     sesso: 'M',
            //     giorno: 9,
            //     mese: 5,
            //     anno: 1977,
            //     comune: 'Rho'  // nome comune italiano o codice catastale
            // });

            // console.log(cf.cf); // codice fiscale generato





            var errore = "";

            console.log("COLLABORATORE: ", that.collaboratore);



            if (that.collaboratore.name == "") {
                errore = "Specificare il nome";
            }

            if (errore == "") {
                if (that.collaboratore.surname == "") {
                    errore = "Specificare il cognome";
                }
            }

            if (errore == "") {
                if (that.collaboratore.mail == "") {
                    errore = "Specificare la mail";
                }
            }

            if (errore == "") {
                if (that.collaboratore.tel_cell == "") {
                    errore = "Specificare il cellulare";
                }
            }

            if (errore == "") {
                if (that.collaboratore.data_nascita == "") {
                    errore = "Specificare la data di nascita";
                }
            }

            if (errore == "") {
                if (that.collaboratore.codice_fiscale == "") {
                    errore = "Specificare il codice fiscale";
                }
            }



            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "") {
            //         errore = "Specificare il titolo di studio";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_in == "") {
            //         errore = "Specificare il valore di in nella sezione diploma";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_anno == "") {
            //         errore = "Specificare il valore di anno nella sezione diploma";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_istituto == "") {
            //         errore = "Specificare il valore di istituto nella sezione diploma";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_voto == "") {
            //         errore = "Specificare il valore di voto nella sezione diploma";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_citta == "") {
            //         errore = "Specificare il valore di città nella sezione diploma";
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.diploma_provincia == "") {
            //         errore = "Specificare il valore di provincia nella sezione diploma";
            //     }
            // }


            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_in == "") {
            //             errore = "Specificare il valore di in nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.idtipolaurea == "") {
            //             errore = "Specificare il valore di tipo laurea nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_istituto == "") {
            //             errore = "Specificare il valore di istituto nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_data_iscrizione == "") {
            //             errore = "Specificare il valore di data registrazione nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_data_termine == "") {
            //             errore = "Specificare il valore di data fine nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_voto == "") {
            //             errore = "Specificare il valore di voto nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_citta == "") {
            //             errore = "Specificare il valore di città nella sezione laurea";
            //         }
            //     }
            // }

            // if (errore == "") {
            //     if (that.collaboratore.titolo_studio == "Laurea") {
            //         if (that.collaboratore.laurea_provincia == "") {
            //             errore = "Specificare il valore di provincia nella sezione laurea";
            //         }
            //     }
            // }

            if (errore == "") {
                if (that.collaboratore.indirizzo == "") {
                    errore = "Specificare il valore di indirizzo nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.regione_res == "") {
                    errore = "Specificare il valore di regione nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_res == "") {
                    errore = "Specificare il valore di provincia nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_res == null) {
                    errore = "Specificare il valore di provincia nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_res == "") {
                    errore = "Specificare il valore di comune nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_res == null) {
                    errore = "Specificare il valore di comune nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.cap_res == "") {
                    errore = "Specificare il valore di CAP nella sezione residenza";
                }
            }

            if (errore == "") {
                if (that.collaboratore.indirizzo_dom == "") {
                    errore = "Specificare il valore di indirizzo nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.regione_dom == "") {
                    errore = "Specificare il valore di regione nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_dom == "") {
                    errore = "Specificare il valore di provincia nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.provincia_dom == null) {
                    errore = "Specificare il valore di provincia nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_dom == "") {
                    errore = "Specificare il valore di comune nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.citta_dom == null) {
                    errore = "Specificare il valore di comune nella sezione domicilio";
                }
            }

            if (errore == "") {
                if (that.collaboratore.cap_dom == "") {
                    errore = "Specificare il valore di CAP nella sezione domicilio";
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-fronte")[0].files.length == 0) {
                    errore = "Specificare il file fronte della carta d'identità";
                }
            }


            if (errore == "") {
                if ($("#input-file-ci-fronte")[0].files.length > 0) {
                    var estensione = $("#input-file-ci-fronte")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione != "pdf") && (estensione != "jpeg") && (estensione != "jpg") && (estensione != "gif") && (estensione != "png")) {
                        errore = "Formati accettati nel file fronte della carta d'identità PDF, JPEG, JPG, GIF, PNG";

                    }
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-retro")[0].files.length == 0) {
                    errore = "Specificare il file retro della carta d'identità";
                }
            }

            if (errore == "") {
                if ($("#input-file-ci-retro")[0].files.length > 0) {
                    var estensione2 = $("#input-file-ci-retro")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione2 != "pdf") && (estensione2 != "jpeg") && (estensione2 != "jpg") && (estensione2 != "gif") && (estensione2 != "png")) {
                        errore = "Formati accettati nel file retro della carta d'identità PDF, JPEG, JPG, GIF, PNG";

                    }
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-fronte")[0].files.length == 0) {
                    errore = "Specificare il file fronte del codice fiscale";
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-fronte")[0].files.length > 0) {
                    var estensione3 = $("#input-file-cf-fronte")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione3 != "pdf") && (estensione3 != "jpeg") && (estensione3 != "jpg") && (estensione3 != "gif") && (estensione3 != "png")) {
                        errore = "Formati accettati nel file fronte del codice fiscale PDF, JPEG, JPG, GIF, PNG";
                    }
                }
            }


            if (errore == "") {
                if ($("#input-file-cf-retro")[0].files.length == 0) {
                    errore = "Specificare il file retro del codice fiscale";
                }
            }

            if (errore == "") {
                if ($("#input-file-cf-retro")[0].files.length > 0) {
                    var estensione4 = $("#input-file-cf-retro")[0].files[0].name.split('.').pop().toLowerCase();
                    if ((estensione4 != "pdf") && (estensione4 != "jpeg") && (estensione4 != "jpg") && (estensione4 != "gif") && (estensione4 != "png")) {
                        errore = "Formati accettati nel file retro del codice fiscale PDF, JPEG, JPG, GIF, PNG";
                    }
                }
            }



            if (errore == "") {



                console.log("ok");

                that.saveData();

            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },

        saveData: async function () {



            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            that.collaboratore.companyid = window.idAziendaCandidato;

            that.collaboratore.tel_cell = that.collaboratore.tel_cell.replace(/\s+/g, "");


            response = await apitimesheet.saveDataCreateColl(
                that.collaboratore,
                $('#input-file-ci-fronte')[0].files[0],
                $('#input-file-ci-retro')[0].files[0],
                $('#input-file-cf-fronte')[0].files[0],
                $('#input-file-cf-retro')[0].files[0]
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from sendMailCreateColl", res);

                that.$swal({
                    icon: "success",
                    text: "Dati salvati correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });


                setTimeout(() => {


                    that.$router.push('/')

                }, 2000);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );









        },




    },

    components: {
        DatePicker, VueAutonumeric
    },

})
</script>

<style>
.editDatiColl .subTitle {
    background: #8080808c;
    height: 20px;
    padding: 0;
    margin-left: 7px;
    min-width: 435px;
    padding-left: 5px;
    margin-bottom: 10px;
    max-width: 435px
}

.editDatiColl .subTitle div {
    font-size: 12px;
    padding-left: 3px;
    padding-top: 3px;
    font-weight: bold;
}




#rowCIFronte .dropify-clear img {
    width: 20px !important;
}

#rowCIFronte .dropify-wrapper {
    height: 236px !important;
    width: 430px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

#rowCIFronte label {
    margin-left: 12px !important;
    font-size: 11px;
}



#rowCIRetro .dropify-clear img {
    width: 20px !important;
}

#rowCIRetro .dropify-wrapper {
    height: 236px !important;
    width: 430px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

#rowCIRetro label {
    margin-left: 12px !important;
    font-size: 11px;
}







#rowCFFronte .dropify-clear img {
    width: 20px !important;
}

#rowCFFronte .dropify-wrapper {
    height: 236px !important;
    width: 430px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

#rowCFFronte label {
    margin-left: 12px !important;
    font-size: 11px;
}







#rowCFRetro .dropify-clear img {
    width: 20px !important;
}

#rowCFRetro .dropify-wrapper {
    height: 236px !important;
    width: 430px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

#rowCFRetro label {
    margin-left: 12px !important;
    font-size: 11px;
}








.editDatiColl .copyAddress {
    cursor: pointer;
    margin-left: 10px;
}


#firmaCanvas {
    border: 1px solid black;
}


.titleSignature {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
}

.subtitleSignature {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    margin-top: 0px;
}



canvas {
    border: 1px solid #c7c4a9;
    margin-top: 10px;
}

#container-view-pdf {
    display: flex;
    flex-direction: column;
    align-items: center;
}


.cl_importo {
    padding-left: 0px !important;
}


.itemAzienda {
    margin-left: 15px;
}

.itemRisorsa {
    margin-left: 15px;
}

.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetRisorse {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.itemGruppo {
    margin-left: 15px;
}

.headerSheetGruppi {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}





.closeSheet {
    position: absolute;
    right: 10px;
    top: 26px;
    z-index: 2;
}

.w-container-dati-coll {
    width: 500px;
    padding: 0px;
}

.v-form {
    margin-top: 41px;
}

.mainTitle {
    padding: 20px !important;
    position: fixed;
    min-width: 500px;
    z-index: 1;
    top: 67px;
    border: 1px solid black;
}

.editDatiColl {
    overflow-x: hidden;
}

.editDatiColl .v-form {
    margin-top: 41px;
    padding-left: 10px;
    padding-right: 10px;
}

.editDatiColl .v-input {
    font-size: 1.2em !important;
}

.editDatiColl .v-select {
    font-size: 1.2em !important;
}

.editDatiColl .v-label {
    font-size: 1em !important;
}

.v-tabs:not(.v-tabs--vertical) .v-tab {
    white-space: normal;
    font-size: 12px;
    padding: 0px;
}

@media screen and (max-width: 768px) {

    .v-form {

        padding-top: 45px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .w-container {
        width: 100vw;
        padding: initial;
        padding: inherit;
    }

    .mainTitle {
        padding: 20px !important;
        position: fixed;
        min-width: 100vw;
        left: 0;
        z-index: 1;
        top: 57px;
    }

    .w-container-dati-coll {
        width: 100vw;
        padding: initial;
        padding: inherit;
    }

    .editDatiColl .subTitle {
        background: #8080808c;
        height: 20px;
        padding: 0;
        margin-left: 7px;
        min-width: 384px;
        padding-left: 5px;
        margin-bottom: 10px;
        max-width: 384px
    }

    .editDatiColl .subTitle div {
        font-size: 12px;
        padding-left: 3px;
        padding-top: 3px;
        font-weight: bold;
    }




    #rowCIFronte .dropify-clear img {
        width: 20px !important;
    }

    #rowCIFronte .dropify-wrapper {
        height: 236px !important;
        width: 380px !important;
        margin-bottom: 20px !important;
        margin-left: 10px !important;
    }

    #rowCIFronte label {
        margin-left: 12px !important;
        font-size: 11px;
    }



    #rowCIRetro .dropify-clear img {
        width: 20px !important;
    }

    #rowCIRetro .dropify-wrapper {
        height: 236px !important;
        width: 380px !important;
        margin-bottom: 20px !important;
        margin-left: 10px !important;
    }

    #rowCIRetro label {
        margin-left: 12px !important;
        font-size: 11px;
    }







    #rowCFFronte .dropify-clear img {
        width: 20px !important;
    }

    #rowCFFronte .dropify-wrapper {
        height: 236px !important;
        width: 380px !important;
        margin-bottom: 20px !important;
        margin-left: 10px !important;
    }

    #rowCFFronte label {
        margin-left: 12px !important;
        font-size: 11px;
    }







    #rowCFRetro .dropify-clear img {
        width: 20px !important;
    }

    #rowCFRetro .dropify-wrapper {
        height: 236px !important;
        width: 380px !important;
        margin-bottom: 20px !important;
        margin-left: 10px !important;
    }

    #rowCFRetro label {
        margin-left: 12px !important;
        font-size: 11px;
    }

    .editDatiColl .copyAddress {
        cursor: pointer;
        margin-left: 10px;
    }



}

.theme--light.v-tabs>.v-tabs-bar,
.theme--light.v-tabs-items {
    background-color: transparent;
}
</style>
